import api from "./baseApi";
import endpoints from "./endpoints";

// ================= GET PROMOTIONS =================

export const getPromotions = async (params = {}) => {
  try {
    const res = await api.get(endpoints.promotion.base, {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 10,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        ...(params.filters || {}),
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch promotions";
    throw new Error(message);
  }
};

// ================= GET PROMOTION BY ID =================

export const getPromotionById = async (id) => {
  try {
    const res = await api.get(endpoints.promotion.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch promotion";
    throw new Error(message);
  }
};

// ================= CREATE PROMOTION =================

export const createPromotion = async (payload) => {
  try {
    const formData = new FormData();

    formData.append("promoCode", payload.promoCode);
    formData.append("startDate", payload.startDate);
    formData.append("noExpiry", payload.noExpiry ? "true" : "false");

    if (!payload.noExpiry && payload.endDate) {
      formData.append("endDate", payload.endDate);
    }

    formData.append(
      "termsAndConditions",
      payload.termsAndConditions || ""
    );

    formData.append("formula", JSON.stringify(payload.formula || {}));
    formData.append("rules", JSON.stringify(payload.rules || {}));
    formData.append("items", JSON.stringify(payload.items || []));

    if (payload.bannerImage) {
      formData.append("bannerImage", payload.bannerImage);
    }

    const res = await api.post(endpoints.promotion.base, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create promotion";
    throw new Error(message);
  }
};

// ================= UPDATE PROMOTION =================

export const updatePromotion = async (id, payload) => {
  try {
    const res = await api.put(endpoints.promotion.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update promotion";
    throw new Error(message);
  }
};

// ================= DELETE PROMOTION =================

export const deletePromotion = async (id) => {
  try {
    const res = await api.delete(endpoints.promotion.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete promotion";
    throw new Error(message);
  }
};

// ================= GET PROMOTION SELECTION DATA =================

export const getPromotionSelectionData = async () => {
  try {
    const res = await api.get(
      endpoints.promotion.selectionData
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "failed to load promotion selection data";

    throw new Error(message);
  }
};